<template>
  <div class="main">
    <div ref="queryContent" v-sticky="{zIndex: 2001, stickyTop: 0, disabled: false}">
      <div class="header-wrapper">
        <el-form :disabled="isListLoading" :model="queryForm" ref="queryForm" :inline="true" label-width="0" :show-message="false">
          <div class="d-flex justify-content-between">
            <div class="filter-wrapper mr-2">
              <div class="filter-container">
                <div class="filter-item mr-3">
                  <label>文章标题：</label>
                  <el-form-item prop="title" class="inline-form-item">
                    <el-input v-model.trim="queryForm.title" clearable class="filter-input"></el-input>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>广告主：</label>
                  <el-form-item prop="groupId" class="inline-form-item">
                    <el-select v-model="queryForm.groupId" clearable class="filter-input">
                      <el-option
                        v-for="item in adUserList"
                        :key="item.CustomerId"
                        :label="item.RealName"
                        :value="item.CustomerId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>分类：</label>
                  <el-form-item prop="groupId" class="inline-form-item">
                    <el-select v-model="queryForm.catId" clearable class="filter-input">
                      <el-option label="全部分类" :value="null"></el-option>
                      <el-option
                          v-for="item in cateList"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>链接类型：</label>
                  <el-form-item prop="groupId" class="inline-form-item">
                    <el-select v-model="queryForm.linkType" clearable class="filter-input">
                      <el-option label="全部类型" :value="null"></el-option>
                      <el-option label="微信链接" value="1"></el-option>
                      <el-option label="其他链接" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>状态：</label>
                  <el-form-item prop="status" class="inline-form-item">
                    <el-select v-model="queryForm.status" class="filter-input">
                      <el-option label="全部状态" :value="null"></el-option>
                      <el-option
                        v-for="item in statusOptions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>排序：</label>
                  <el-form-item prop="order" class="inline-form-item">
                    <el-select v-model="queryForm.order" class="filter-input">
                      <el-option
                        v-for="item in orderOptions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="filter-item">
                  <el-button :loading="isListLoading" :disabled="isStatusChanging" @click="fetchData" type="primary" class="query-button" icon="el-icon-search">查询</el-button>
                  <el-button :disabled="isListLoading || isStatusChanging" @click="resetQueryForm" class="query-button">重置</el-button>
                </div>
              </div>
            </div>
            <div class="tools flex-shrink-0">
              <div class="filter-item">
                <el-button :disabled="isListLoading || isStatusChanging" @click="edit('')" type="warning" class="query-button">添加文章</el-button>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="main-content">
        <el-table
          ref="table"
          :data="rawListData"
          v-loading="isListLoading"
          border
          fit
          highlight-current-row
          style="width: 100%;"
          row-style="height:80px"
          :max-height="tableMaxHeight">
          <el-table-column
            width="60"
            prop="Id"
            label="文章ID">
          </el-table-column>
          <el-table-column
            width="200"
            prop="Title"
            label="文章标题">
          </el-table-column>
          <el-table-column
            width="250"
            prop="Url"
            label="文章链接">
            <template slot-scope="scope">
              <div
                  style="display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 3;
                  overflow: hidden;">
                {{ scope.row.Url }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="80"
            prop="LinkType"
            label="链接类型">
            <template slot-scope="scope">
              <div>{{ scope.row.LinkType === '1' ? '微信链接' : '其他链接' }}</div>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            prop="SourceGzh"
            label="来源公众号">
          </el-table-column>
          <el-table-column
              width="90"
              prop="SourceGzh"
              label="公众号分类">
            <template slot-scope="scope">
              <div>{{ cateMap.get(scope.row.CatId) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            width="70"
            label="广告主">
            <template slot-scope="scope">
              <div>{{ adUserMap.get(scope.row.GroupId) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            width="80"
            prop="DayCount"
            label="每日目标阅读量">
          </el-table-column>
          <el-table-column
            width="80"
            prop="TotalCount"
            label="目标总阅读量">
          </el-table-column>
          <el-table-column
            width="80"
            prop="RealTotalCount"
            label="实时阅读总量">
          </el-table-column>
          <el-table-column
            width="80"
            prop="RealTotalCount"
            label="实时收益">
            <template slot-scope="scope">
              <div>{{ scope.row.Price *  scope.row.RealTotalCount / 100}}元</div>
            </template>
          </el-table-column>
          <el-table-column
            width="160"
            label="展示时间限制">
            <template slot-scope="scope">
              <div>{{ scope.row.StartTime + ' - ' + scope.row.EndTime }}</div>
            </template>
          </el-table-column>
          <el-table-column
            width="60"
            prop="Sort"
            label="排序">
          </el-table-column>
          <el-table-column
            width="60"
            label="状态">
            <template slot-scope="scope">
              <div>{{ statusMap.get(scope.row.Status) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button @click="edit(scope.row.Id)" type="text">修改</el-button>
              <el-button
                  @click="changeStatus(scope.row)"
                  :loading="isStatusChanging && currentId === scope.row.Id"
                  :disabled="isListLoading || (isStatusChanging && currentId !== scope.row.Id)"
                  type="text">
                {{ +scope.row.Status === 1 ? '禁用' : '启用' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="text-center py-3">
          <el-pagination
            :disabled="isListLoading"
            @current-change="handleCurrentChange"
            @size-change="handlePageSizeChange"
            :current-page.sync="tableCurrentPage"
            :page-sizes="tablePageSizeOption"
            :page-size="tablePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableTotalSize"
            background>
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSticky from 'vue-sticky'
import AccountApi from '@/api/Account'
import * as JumpAmountApi from '@/api/jumpAmount'
import swal from 'sweetalert2'
import { deepClone } from '@/utils'

export default {
  name: 'jump-amount-article-management',
  directives: {
    sticky: VueSticky
  },
  data() {
    const title = null
    const groupId = null
    const linkType = null
    const status = '1'
    const order = '1'
    const catId = null
    return {
      queryForm: {
        // 文章标题
        title,
        // 广告主
        groupId,
        // 链接类型
        linkType,
        // 状态
        status,
        // 排序
        order,
        catId
      },
      statusOptions: [
        {
          name: '启用',
          value: '1'
        }, {
          name: '禁用',
          value: '0'
        }
      ],
      orderOptions: [
        {
          name: '按排序值降序',
          value: '1'
        }, {
          name: '按添加时间降序',
          value: '2'
        }, {
          name: '按添加时间升序',
          value: '3'
        }
      ],
      adUserList: [],
      cateList: [],

      isListLoading: false,
      isStatusChanging: false,

      currentId: null,

      // 保存之前的请求参数
      query: deepClone({ title, groupId, status, order, catId }),

      rawListData: [],

      // 表格当前页
      tableCurrentPage: 1,
      // 表格一页条数可选项
      tablePageSizeOption: [10, 20, 30],
      // 表格一页条数
      tablePageSize: 20,
      // 总条数
      tableTotalSize: 0,

      // 除表格外内容区域高度
      othersHeight: 0
    }
  },
  computed: {
    statusMap() {
      return new Map(this.statusOptions.map(item => [item.value, item.name]))
    },
    adUserMap() {
      return new Map(this.adUserList.map(item => [item.CustomerId, item.RealName]))
    },
    tableMaxHeight() {
      return Math.max(this.$store.getters.containerHeight - this.othersHeight, 300)
    },
    cateMap() {
      return new Map(this.cateList.map(item => [item.key, item.value]))
    }
  },
  created() {
    this.getAdUsers()
    this.getCateList()
    this.fetchData()
    const { path, query } = this.$route
    const { refresh, ...otherQuery } = query
    if (refresh) {
      query.refresh = false
      this.$nextTick(() => {
        this.$router.replace({
          path: path,
          query: otherQuery
        })
      })
    }
  },
  mounted() {
  },
  activated() {
    const { path, query } = this.$route
    const { refresh, ...otherQuery } = query
    if (refresh) {
      if (refresh === '1') {
        this.fetchData()
      } else if (refresh === '2') {
        this.fetchList()
      }
      this.$router.replace({
        path: path,
        query: otherQuery
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      const queryContent = this.$refs.queryContent
      const queryContentHeight = queryContent ? Math.round(queryContent.clientHeight) : 0
      this.othersHeight = queryContentHeight + 41 + 64
    })
  },
  methods: {
    // 重置查询
    resetQueryForm() {
      this.$refs.queryForm.resetFields()
    },
    getAdUsers() {
      AccountApi.getAdUsers().then(({ data }) => {
        if (data.Status === 200) {
          this.adUserList = data.Result instanceof Array ? data.Result : []
        }
      })
    },
    getCateList() {
      AccountApi.getInfoByName({ name: 'jumpLinkCateList' }).then(({ data }) => {
        if (data.Status === 200) {
          this.cateList = data.Result
        }
      })
    },
    fetchData() {
      // 克隆当前查询条件
      this.query = deepClone(this.queryForm)
      this.tableCurrentPage = 1
      this.tableTotalSize = 0

      this.fetchList()
    },
    fetchList() {
      this.isListLoading = true
      this.rawListData = []

      const { title, groupId, status, order, catId, linkType } = this.query

      const postData = {
        page: this.tableCurrentPage,
        limit: this.tablePageSize
      }
      linkType && (postData.linkType = linkType)
      title && (postData.title = title)
      groupId && (postData.groupId = groupId)
      status && (postData.status = status)
      catId && (postData.catId = catId)
      if (order === '1') {
        postData.orderField = 'Sort'
        postData.order = 'DESC'
      } else if (order === '2') {
        postData.orderField = 'CreateTime'
        postData.order = 'DESC'
      } else if (order === '3') {
        postData.orderField = 'CreateTime'
        postData.order = 'ASC'
      }

      JumpAmountApi.getArticlePageList(postData).then(({ data }) => {
        this.isListLoading = false
        if (data.Status !== 200) {
          swal({
            text: data.Result.ErrorMsg,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }
        this.rawListData = data.Result.list
        this.tableTotalSize = parseInt(data.Result.count) || 0
      }).catch(error => {
        swal({
          text: error.message,
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        })
        this.isListLoading = false
      })
    },
    handleCurrentChange(value) {
      this.fetchList()
    },
    handlePageSizeChange(value) {
      this.tableCurrentPage = 1
      this.tablePageSize = value
      this.fetchList()
    },
    // 修改状态
    changeStatus(row) {
      this.currentId = row.Id
      this.$confirm(`确定要${+row.Status === 1 ? '禁用' : '启用'}文章“${row.Title}”吗？`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.isStatusChanging = true
        const postData = {
          id: row.Id,
          status: +row.Status === 1 ? 0 : 1
        }
        JumpAmountApi.editArticleStatus(postData).then(({ data }) => {
          this.isStatusChanging = false
          if (data.Status !== 200) {
            this.$message({
              message: data.Result.ErrorMsg,
              type: 'error',
              duration: 2000
            })
            return
          }
          this.$message({
            message: `${+row.Status === 1 ? '禁用' : '启用'}成功`,
            type: 'success',
            duration: 2000
          })
          this.fetchList()
        }).catch(() => {
          this.isStatusChanging = false
        })
      }).catch(() => {
      })
    },
    edit(id) {
      this.$store.dispatch('delCachedViews', this.$router.match('/edit-jump-amount-article')).then(() => {
        this.$nextTick(() => {
          this.$router.push({
            path: '/edit-jump-amount-article',
            query: id ? {
              id: id
            } : {}
          })
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  display: table;
  table-layout: fixed;
  min-width: 1300px;
  width: 100%;
  height: 100%;
  background-color: #ececec;
  .filter-item {
    margin-bottom: 15px;
  }
  .filter-container {
    .filter-item {
      display: inline-block;
      white-space: nowrap;
    }
  }
  .filter-input {
    width: 200px;
  }
  .query-button {
    width: 100px;
  }
  .tool-button {
    width: 100px;
  }
  .oper-button {
    width: 80px;
  }
  .header-wrapper {
    padding: 14px 20px 0;
    box-shadow: 0 1px 3px rgba(0,0,0,.1);
    background-color: #fff;
  }
  .content-wrapper {
    padding: 20px;
    .main-content {
      border-top: 1px solid #e1e3e4;
      border-left: 1px solid #e1e3e4;
      border-right: 1px solid #e1e3e4;
      background-color: #fff;
      .button-wrapper {
        padding: 20px 20px;
      }
    }
  }
  .inline-form-item {
    display: inline-block;
    margin: 0;
    vertical-align: middle;
  }
}
</style>
